import {cn} from '@features/ui/utils';

export type PlanType = 'individual' | 'team';

const planTypes: PlanType[] = ['individual', 'team'];

interface PlanTypeSelectorProps {
  value: PlanType;
  onChange: (value: PlanType) => void;
}

export function PlanTypeSelector({value, onChange}: PlanTypeSelectorProps) {
  return (
    <div className='inline-flex rounded-full bg-muted p-1'>
      {planTypes.map((type) => (
        <button
          key={type}
          onClick={() => onChange(type)}
          className={cn(
            'rounded-full px-3 py-1.5 text-sm font-semibold capitalize transition-colors',
            value === type
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </button>
      ))}
    </div>
  );
}
